module.exports = __webpack_public_path__ + "media/images/pages/logo_brand_01-f5f574e5f5e7850901e736ce4f71dea8.png";